"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mui_1 = require("tss-react/mui");
const InputBase_1 = __importDefault(require("@mui/material/InputBase"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const utils_1 = require("utils/utils");
const styles_1 = require("./styles");
const useStyle = (0, mui_1.makeStyles)()(styles_1.inputStyles);
const Input = ({ tagValue, onChange, onKeyDown, isEditing = false, placeholder = 'NewTag', id, hideHiddenSpan }) => {
    const [width, setWidth] = (0, react_1.useState)(null);
    const spanRef = (0, react_1.useRef)(null);
    const { classes } = useStyle();
    const calcWidth = (0, react_1.useCallback)(() => {
        const spanEl = spanRef.current;
        const minWidth = 60;
        let widthCalc = (spanEl === null || spanEl === void 0 ? void 0 : spanEl.offsetWidth) || 0;
        widthCalc = widthCalc === 0 ? minWidth : widthCalc;
        widthCalc = !(0, utils_1.isOldEdge)() ? widthCalc + 20 : widthCalc + 6;
        setWidth(widthCalc);
    }, []);
    (0, react_1.useEffect)(() => {
        calcWidth();
    }, [tagValue, calcWidth]);
    const widthStyles = width ? { width } : {};
    return (<div className={classes.container}>
      <InputBase_1.default id={id} readOnly={!isEditing} style={Object.assign({}, widthStyles)} autoFocus={isEditing} classes={{ root: classes.inputRoot, input: classes.input, disabled: classes.disabled }} onChange={onChange} onKeyDown={onKeyDown} value={tagValue} autoComplete="off" placeholder={placeholder} inputProps={{
            maxLength: 32,
            name: 'tagValue',
        }}/>
      <Typography_1.default ref={spanRef} className={classes.hiddenSpan} component="span" variant="body1" display="inline" sx={{ visibility: hideHiddenSpan ? 'hidden' : 'visible' }}>
        {tagValue}
      </Typography_1.default>
    </div>);
};
exports.default = Input;
